import LogoWithTextUrl from '@assets/logo-with-text.svg';
import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { Link } from 'react-router';

export const NavbarWithoutHeader = () => {
  return (
    <Header>
      <Link to="/admin/events">
        <img src={LogoWithTextUrl} alt="» Racemap" />
      </Link>
    </Header>
  );
};

const Header = styled.div`
  align-items: flex-start;
  width: 100%;
  height: 50px;
  background-color: ${RacemapColors.CloudBlue};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  border-bottom: 1px solid ${RacemapColors.LightGray};

  img {
    margin-left: 15px;
    height: 50px;
    opacity: 0.6;
  }
`;
